import $ from 'jquery';

$(document).ready(function () {
  acfQuickLinkBlock();
});

function acfQuickLinkBlock() {
  $('.js-acf-quick-link').each(function () {});
}
